$(document).ready(function () {

  function handleScrollOrRedirect(sectionId) {
    var target = $(sectionId);
    
    if (target.length) {
      $('html, body').stop(true, false).animate({
        scrollTop: target.offset().top - 120
      }, 600);
    } else {
      window.location.href = '/' + sectionId;
    }
  }

  $('a[href="#science-behind-daily-core"]').on('click', function (e) {
    e.preventDefault();
    handleScrollOrRedirect('#science-behind-daily-core');
  });

  $('a[href="#founder-story"]').on('click', function (e) {
    e.preventDefault();
    handleScrollOrRedirect('#founder-story');
  });

  function scrollToHash() {
    var hash = window.location.hash;
    if (hash && $(hash).length) {
      setTimeout(function() {
        $('html, body').stop(true, false).animate({
          scrollTop: $(hash).offset().top - 120
        }, 600);
      }, 100);
    }
  }

 
  if (window.location.hash) {
    scrollToHash();
  }
  
 
  $(document).ready(function() {
    scrollToHash();
  });
  
 
  $(window).on('load', function() {
    scrollToHash();
  });
  
 
  $(window).on('hashchange', function() {
    scrollToHash();
  });

});
